import type { AgencyInfo } from "@/components/SiteHeader";
import { SITE, ADDRESS_LINE } from "./site-config";

export type AgencyDetails = AgencyInfo & {
  area: string;
  city: string;
  address: string;
};

/**
 * UI-facing business details. Derived from the single source of truth in
 * `site-config.ts` - edit the facts there, not here.
 */
export const AGENCY: AgencyDetails = {
  name: SITE.name,
  short: SITE.short,
  phone: SITE.phone,
  phoneHref: `tel:${SITE.phoneE164}`,
  hours: SITE.hoursHuman,
  area: SITE.areaLabel,
  city: `${SITE.address.locality}, ${SITE.address.region}`,
  address: ADDRESS_LINE,
};
